
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_45725","data-name":"Group 45725","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15380","data-name":"Rectangle 15380","width":"25","height":"25","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_45724","data-name":"Group 45724","clip-path":"url(#clip-path)","fill":"#5251f8"}},[_c('path',{attrs:{"id":"Path_32869","data-name":"Path 32869","d":"M23.47 19.9a3.053 3.053 0 00-2.13-2.158V15.3a.754.754 0 000-.4V7.192a3.052 3.052 0 10-3.8-3.64H7.439a3.054 3.054 0 10-3.857 3.623v10.581a3.052 3.052 0 103.829 3.706h10.158a3.053 3.053 0 005.937-1.426 3.193 3.193 0 00-.037-.14m-4.34-16.343a1.555 1.555 0 112.21 2.022 1.519 1.519 0 01-1.5.085 1.578 1.578 0 01-.888-1.4 1.524 1.524 0 01.178-.709M7.411 5.052h10.158A3.055 3.055 0 0019.84 7.24v6.012l-1.127-1.126a2.706 2.706 0 00-3.735 0l-.653.653-2.534-2.53a2.676 2.676 0 00-3.7 0l-3.009 3.016V7.258a3.061 3.061 0 002.329-2.206m-4.5-.791A1.555 1.555 0 014.461 2.7h.01a1.558 1.558 0 11-1.56 1.56m1.56 17.968a1.547 1.547 0 111.56-1.554 1.579 1.579 0 01-1.56 1.559m13.069-2.266H7.44a3.069 3.069 0 00-2.358-2.292v-2.289l4.076-4.076a1.139 1.139 0 011.576 0l3.023 3.022.036.039a.342.342 0 00.04.036l1.176 1.177a.75.75 0 101.061-1.061l-.684-.683.653-.653a1.167 1.167 0 011.614 0l2.187 2.188v2.316a3.061 3.061 0 00-2.3 2.273m4.36 1.42a1.558 1.558 0 01-1.389.847 1.578 1.578 0 01-1.56-1.556 1.52 1.52 0 01.178-.708 1.557 1.557 0 112.792 1.379l-.021.041"}}),_c('path',{attrs:{"id":"Path_32870","data-name":"Path 32870","d":"M14.3 9.9a1.061 1.061 0 10-1.061-1.062A1.061 1.061 0 0014.3 9.9"}})])])
          )
        }
      }
    